import { TCoreInputOptions } from '../types/options';

const px = (value: unknown): string | undefined => (typeof value === 'number' ? `${value}px` : undefined);

export const buildInputCssVars = (palette: TCoreInputOptions): Record<string, string> => {
    const margin = palette.margin ?? {};
    const padding = palette.padding ?? {};
    const isFilled = !!palette.surfaceContainerHighest;
    const hideOutline = palette.outline === 'transparent';
    const radius = px(palette.borderRadius) ?? '4px';

    const vars: Record<string, string | undefined> = {
        '--cw-inp-radius': px(palette.borderRadius),
        // colors
        '--cw-inp-color': palette.onSurface,
        '--cw-inp-color-hover': palette.onSurfaceHovered,
        '--cw-inp-bg': palette.surfaceContainerHighest,
        '--cw-inp-caret-color': palette.main,
        '--cw-inp-border-color': palette.outline,
        '--cw-inp-border-color-focus': hideOutline ? 'transparent' : palette.main,
        '--cw-inp-text-align': palette.textAlign,
        '--cw-inp-border-color-error': palette.error,
        '--cw-inp-border-color-disabled': palette.onSurface,
        '--cw-inp-label-color': palette.onSurfaceVariant,
        '--cw-inp-label-color-focus': palette.main,
        '--cw-inp-label-color-error': palette.error,
        '--cw-inp-label-color-disabled': palette.onSurface,
        '--cw-inp-helper-color': palette.onSurfaceVariant,
        '--cw-inp-helper-color-error': palette.error,
        // typography
        '--cw-inp-font-family': palette.font,
        '--cw-inp-font-weight': typeof palette.fontStyle?.fontWeight === 'number' ? palette.fontStyle.fontWeight.toString() : undefined,
        '--cw-inp-font-size': px(palette.fontStyle?.fontSize),
        '--cw-inp-line-height': px(palette.fontStyle?.lineHeight),
        '--cw-inp-font-size-xl': px(palette.fontStyle?.fontSizeXl),
        '--cw-inp-line-height-xl': px(palette.fontStyle?.lineHeightXl),
        '--cw-inp-letter-spacing': px(palette.fontStyle?.letterSpacing),
        // sizing
        '--cw-inp-height': px(palette.height),
        // spacing
        '--cw-inp-margin-top': px(margin.top),
        '--cw-inp-margin-right': px(margin.right),
        '--cw-inp-margin-bottom': px(margin.bottom),
        '--cw-inp-margin-left': px(margin.left),
        '--cw-inp-padding-top': px(padding.top),
        '--cw-inp-padding-right': px(padding.right),
        '--cw-inp-padding-bottom': px(padding.bottom),
        '--cw-inp-padding-left': px(padding.left),
        '--cw-inp-fieldset-display': isFilled || hideOutline ? 'none' : undefined,
        '--cw-inp-nativeinput-bg': isFilled ? (palette.surfaceContainerHighest ?? 'transparent') : undefined,
        '--cw-inp-nativeinput-radius': isFilled ? `${radius} ${radius} 0 0` : undefined,
        '--cw-inp-nativeinput-border-bottom-width': isFilled ? '1px' : undefined,
        '--cw-inp-nativeinput-pt': isFilled ? '24px' : undefined,
        '--cw-inp-nativeinput-pb': isFilled ? '8px' : undefined,
        '--cw-inp-underline-display': isFilled ? 'block' : undefined,
        '--cw-inp-label-left': isFilled ? px(padding.left) : undefined,
        '--cw-inp-label-top-floated': isFilled ? '8px' : undefined,
        '--cw-inp-label-transform-floated': isFilled ? 'none' : undefined,
    };

    return Object.fromEntries(Object.entries(vars).filter((entry): entry is [string, string] => entry[1] !== undefined));
};
